<template>
  <VApp>
    <Menu
      :terms="true"
      ref="menu"
      @change="menuTabChange"
      @switchLocale="switchLocale"
      @openMenu="openMenu"
    />

    <VMain>
      <VContainer fluid class="ma-0 pa-0 fill-height">
        <RouterView
          :menuTab="menuTab"
          @menu-tab-change="menuTabChange"
          @saber-mais="knowMore()"
        />
        <Cookie
          v-model:snackbar="showCookieBar"
          @cookie-accept="cookieAccept"
          @cookie-reject="cookieReject"
        />
      </VContainer>
    </VMain>

    <VScrollYReverseTransition>
      <VContainer
        v-if="mobileMenuOpen"
        class="primary"
        fluid
        style="position: fixed; bottom: 10vh; width: 100%; border-top-left-radius: 10%; border-top-right-radius: 10%; z-index: 100;"
      >
        <VCard color="transparent" class="white--text">
          <VCardTitle class="text-uppercase font-weight-bold text-h4">
            Menu
            <VSpacer />
            <VBtn dark icon size="small" @click="mobileMenuOpen = false">
              <VIcon size="x-large">mdi-close</VIcon>
            </VBtn>
          </VCardTitle>

          <VDivider color="white" />

          <VCardText class="white--text text-uppercase font-weight-bold text-body-1">
            <p
              class="ml-16"
              style="display: flex; justify-content: left;"
              @click="menuTabChange('who_we_are'); mobileMenuOpen = false;"
            >
              <VImg
                max-width="30px"
                src="@/assets/icons/icons/png/icons_Prancheta 1-05.png"
              />
              <span class="ml-6">{{ $t('MENU.who_we_are') }}</span>
            </p>
          </VCardText>

          <VCardText class="white--text text-uppercase font-weight-bold text-body-1">
            <p
              class="ml-16"
              style="display: flex; justify-content: left;"
              @click="openReportlake"
            >
              <VImg
                max-width="30px"
                src="@/assets/icons/icons/png/icons_Prancheta 1-32.png"
              />
              <span class="ml-6">Login</span>
            </p>
          </VCardText>
        </VCard>
      </VContainer>
    </VScrollYReverseTransition>

    <!-- footers -->
    <VFooter
      class="d-none d-lg-block flex ma-0 pa-0"
      color="secondary"
      height="auto"
    >
      <Footer />
    </VFooter>

    <VFooter
      class="d-md-none"
      color="secondary"
      style="z-index: 101;"
      height="auto"
      app
    >
      <Footer />
    </VFooter>
  </VApp>
</template>

<script>
import Footer from '@/views/Footer.vue'
import Menu from '@/components/header/Menu.vue'
import Cookie from '@/components/cookies/Cookie.vue'

export default {
  name: 'LayoutTerms',
  components: { Menu, Footer, Cookie },

  data() {
    return {
      mobileMenuOpen: false,
      menuTab: '',
      showCookieBar: false
    }
  },

  computed: {
    showWindowCookie() {
      // mantido para compatibilidade, embora já uses v-model:snackbar
      return this.showCookieBar
    }
  },

  watch: {
    menuTab: {
      immediate: true,
      handler(val) {
        if (val == null || val === '' || val === undefined) return
        // (sem navegação específica aqui, como no original)
      }
    },
    $route: {
      immediate: true,
      handler(val) {
        if (val == null) {
          document.title = 'Reportlake | Software de Gestão de Obra'
          return
        }
        if (val.name === 'Trial') {
          document.title = 'Trial | Reportlake - Software de Gestão de Obra'
          return
        }
        document.title = 'Reportlake | Software de Gestão de Obra'
      }
    }
  },

  mounted() {
    const cookie = this.$cookies.get('reportlake_website_cookie')
    if (cookie == null) this.showCookieBar = true

    if (this.$route.params.lang != null) {
      this.$i18n.locale = this.$route.params.lang
    }
  },

  methods: {
    openReportlake() {
      window.open('https://login.reportlake.com/', '_blank')
    },
    cookieReject() {
      this.$cookies.set('reportlake_website_cookie', null, '1s')
      this.showCookieBar = false
    },
    cookieAccept(ob) {
      this.$cookies.set('reportlake_website_cookie', JSON.stringify(ob), '7d')
      this.showCookieBar = false
    },
    switchLocale(l) {
      this.$i18n.locale = l
      this.$route.params.lang = this.$i18n.locale
      this.$router.push({ name: this.$router.currentRoute.name, params: this.$route.params })
    },
    knowMore() {
      this.$refs.menu?.contactTab?.()
    },
    registerContactEvent() {
      const cookie = this.$cookies.get('reportlake_website_cookie')
      if (!cookie || cookie.statistics === false) return
      this.$gtag.event('contact_tag', {
        event_category: 'Contactos',
        event_label: 'Contactos',
        value: 'contact_tag'
      })
    },
    openMenu() {
      this.mobileMenuOpen = !this.mobileMenuOpen
    },
    menuTabChange(v) {
      this.menuTab = v
    },
    getVersion() {
      return process.env.VUE_APP_SECRET_VERSION
    },
    goTo(place) {
      if (place !== 'contacts' && place !== 'blog') {
        this.$router.push('/' + place)
        return
      }
      this.$router.push(place)
    }
  }
}
</script>
